module.exports = __webpack_public_path__ + "WhatsApp_Logo_5.png?21ddfa3f5122d947b9b9999b9b2d47d2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WhatsApp_Logo_5.png
// module id = 1109
// module chunks = 22